import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import KYCQuestion from "./KYCQuestion";

export default class SizeOfDeposits extends KYCQuestion
{
	state = {
		fields: {
			radio_aml_deposit_amt: {
				options: [
					{
						name: "radio_aml_deposit_amt",
						label: "0 - 100 000 kr",
						value: "0-100",
						checked: false
					},
					{
						name: "radio_aml_deposit_amt",
						label: "100 000 - 250 000 kr",
						value: "100-250",
						checked: false
					},
					{
						name: "radio_aml_deposit_amt",
						label: "250 000 - 500 000 kr",
						value: "250-500",
						checked: false
					},
					{
						name: "radio_aml_deposit_amt",
						label: "500 000 - 1 mkr",
						value: "500-1000",
						checked: false
					},
					{
						name: "radio_aml_deposit_amt",
						label: "Mer än 1 mkr",
						value: ">1mn",
						checked: false
					}
				]
			}
		}
	};

	constructor(props, context)
	{
		super(props, context);
		this.fieldName = "radio_aml_deposit_amt";
	}

	render()
	{
		return (
			<React.Fragment>
				<OptionsList
					style={{marginTop: "35px"}}
					type="radio"
					name="radio_aml_deposit_amt"
					description="Hur stora kommer dina insättningar att vara per år?"
					orientation="vertical"
					onChange={this._onOptionsListChange}
					options={this.state.fields.radio_aml_deposit_amt.options}
				/>
			</React.Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/SizeOfDeposits.js